import api from "@/lib/api";

export type GetChangeDetailRequest = {
  deviceType: string;
  gradeType: string;
  termType: string;
  contractNumber: string;
};

export type GetChangeDetailResponse = {
  basetime: number;
  currencyCode: string;
  settlementScheduledPrice: number;
  settlementScheduledTerm: string;
  settlementScheduledAt?: number;
  instantPayment?: number;
  upcomingTotal?: number;
  currentPlanName: string;
  afterPlanName: string;
  freePeriodAt?: number;
  isChangeSettlementScheduledAt: boolean;
  isInitialMonthInclusiveInvoice?: boolean;
  isMonthlyFreeTrials?: boolean;
  isFreePeriodEnd?: boolean;
  newPlanCode: string;
};

export type PostChangePlansRequest = {
  deviceType: string;
  gradeType: string;
  termType: string;
  contractNumber: string;
  key: string;
  basetime: number;
};

export type PostChangePlansResponse = {
  status: string;
  isSettlementComplete: boolean;
  contractPlanChangeId: number;
  isSmallPayment: boolean;
};

export type PostChangeContractCancelRequest = {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
};

export type PostChangeContractCancelResponse = {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
};

export default {
  getChangeDetail(data: GetChangeDetailRequest) {
    return api<GetChangeDetailRequest, GetChangeDetailResponse>({
      endpoint: "contracts/change-plans-sb/web-api/change-detail",
      method: "GET",
      queryParams: data
    });
  },
  postChangePlans(data: PostChangePlansRequest) {
    return api<PostChangePlansRequest, PostChangePlansResponse>({
      endpoint: "contracts/change-plans-sb/web-api/change",
      method: "POST",
      body: data
    });
  },
  postChangeContractCancel(data: PostChangeContractCancelRequest) {
    return api<
      PostChangeContractCancelRequest,
      PostChangeContractCancelResponse
    >({
      endpoint: "contracts/change-plans-sb/web-api/cancel",
      method: "POST",
      body: data
    });
  }
};
